// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__j1jPC","bannerContent":"Banner_bannerContent__HCrnJ","title":"Banner_title__B6YsH","subtitle":"Banner_subtitle__iVVxd","tagline":"Banner_tagline__rCY7e"};